import { render, staticRenderFns } from "./CollapseMenuIcon.vue?vue&type=template&id=60feba53&"
import script from "./CollapseMenuIcon.vue?vue&type=script&lang=js&"
export * from "./CollapseMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports